import { render, staticRenderFns } from "./CostAnalysis.vue?vue&type=template&id=2b0d95a5&scoped=true"
import script from "./CostAnalysis.vue?vue&type=script&lang=js"
export * from "./CostAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d95a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0d95a5')) {
      api.createRecord('2b0d95a5', component.options)
    } else {
      api.reload('2b0d95a5', component.options)
    }
    module.hot.accept("./CostAnalysis.vue?vue&type=template&id=2b0d95a5&scoped=true", function () {
      api.rerender('2b0d95a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/CostAnalysis.vue"
export default component.exports